import React, { useState } from 'react';

const ApplyNow = () => {
  const [Name, setName] = useState('');
  const [ChildName, setChildName] = useState('');
  const [PNumber, setPNumber] = useState('');
  const [Description, setDescription] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      Name: Name,
      ChildName: ChildName,
      PNumber: PNumber,
      Description: Description
    };

    try {
      //const response = await fetch("https://script.google.com/macros/s/AKfycbxGDAeWIZ6iZuvNosDw42FQNXaWbnLiGoDMvAWPwSSpDlNaAgEaxjgZdBreGynV7U-ByQ/exec", {
        const response = await fetch("https://script.google.com/macros/s/AKfycbz1-UoJOdUQPbZDswla9b-Th-pl8WJmGYN_HnhkNq70rPn93IbaBxcRnIF_4l2Ub7CU4A/exec", {
        
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: new URLSearchParams({
          Name: Name,
          ChildName: ChildName,
          PNumber: PNumber,
          Description: Description
        }).toString()
      });
      

      if (response.ok) {
        alert("Form submitted!");
      } else {
        alert("Submission failed.");
      }
    } catch (err) {
      alert("Error submitting form.");
    }
  };

  return (
    <form className="apply" onSubmit={handleSubmit}>
      <h3 style={{ marginBottom: '20px' }}>Apply Now</h3>

      <div className="input-box">
        <label>Your Name</label>
        <input
          type="text"
          value={Name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
    <div className="input-box">
        <label>Child Name</label>
        <input
          type="text"
          value={ChildName}
          onChange={(e) => setChildName(e.target.value)}
        />
      </div>
      <div className="input-box">
        <label>Inquiry</label>
        <input
          type="text"
          value={Description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </div>

      <div className="input-box">
        <label>Phone Number</label>
        <input
          type="text"
          value={PNumber}
          onChange={(e) => setPNumber(e.target.value)}
        />
      </div>

      <button
        type="submit"
        style={{
          padding: '10px 17px',
          background: '#ab0303',
          border: 0,
          color: '#fff',
          marginTop: '20px'
        }}
      >
        Apply Now
      </button>
    </form>
  );
};

export default ApplyNow;
